export class SegmentBase {
    get Direction() {
        return this.End.sub(this.Start);
    }
    toString() {
        return this.Start + ' ' + this.End;
    }
}
//# sourceMappingURL=SegmentBase.js.map